const builder = (function() {
    let currentStep = 1;
    const totalSteps = 5;
    const MOBILE_BREAKPOINT = 767;
    let isMobileLayout = false;

    const STEP_IDS = [
        'step-width',
        'step-strap',
        'step-buckle-type',
        'step-review'
    ];

    const MERGED_DETAIL_STEP_IDS = [
        'step-end',
        'step-stitch',
        'step-emboss'
    ];

    function isMobileViewport() {
        if (typeof window === 'undefined') return false;
        if (window.matchMedia) {
            return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches;
        }
        return window.innerWidth <= MOBILE_BREAKPOINT;
    }

    function applyViewportMode() {
        const container = document.getElementById('custom-belt-builder');
        const mobile = isMobileViewport();

        isMobileLayout = mobile;

        if (container) {
            container.classList.toggle('builder-mobile', mobile);
        }

        return mobile;
    }

    function init() {
        bindEvents();
        applyViewportMode();
        showStep(1);
        lazyload.init();

        state.subscribe(() => {
            updateProgress();
            updateButtons();
            updateSidePanel();
        });

        const overlay = document.getElementById('builder-loading');
        const container = document.getElementById('custom-belt-builder');
        if (overlay) {
            overlay.style.opacity = '0';
            setTimeout(() => { overlay.style.display = 'none'; }, 400);
        }
        if (container) container.style.visibility = 'visible';

        window.addEventListener('resize', () => {
            const mobile = isMobileViewport();
            const previousMode = isMobileLayout;
            applyViewportMode();
            if (mobile !== previousMode) {
                showStep(currentStep);
            }
        });
    }

    function bindEvents() {
        const nextBtn = document.getElementById('btn-next');
        const prevBtn = document.getElementById('btn-prev');
        const checkoutBtn = document.getElementById('btn-checkout');

        if (nextBtn) nextBtn.addEventListener('click', goNext);
        if (prevBtn) prevBtn.addEventListener('click', goPrev);
        if (checkoutBtn) checkoutBtn.addEventListener('click', () => {
            cart.goToCheckout();
        });

        document.querySelectorAll('.progress-step').forEach(step => {
            step.addEventListener('click', () => {
                const stepNum = parseInt(step.dataset.step, 10);
                if (stepNum <= currentStep) {
                    goToStep(stepNum);
                }
            });
        });

        document.addEventListener('builder:next', goNext);
        document.addEventListener('builder:prev', goPrev);
        document.addEventListener('builder:go-to', (e) => goToStep(e.detail.step));
    }

    function showStep(stepNum) {
        STEP_IDS.forEach((id, index) => {
            const el = document.getElementById(id);
            if (el) {
                el.style.display = (index + 1 === stepNum) ? 'block' : 'none';
            }
        });

        MERGED_DETAIL_STEP_IDS.forEach(id => {
            const el = document.getElementById(id);
            if (el) {
                el.style.display = stepNum === 4 ? 'block' : 'none';
            }
        });

        const stepReview = document.getElementById('step-review');
        if (stepReview) {
            stepReview.style.display = stepNum === 5 ? 'block' : 'none';
        }

        currentStep = stepNum;
        updateProgress();
        updateButtons();

        const sidePanel = document.querySelector('.side-panel');
        if (sidePanel) {
            sidePanel.style.display = (stepNum === totalSteps || isMobileLayout) ? 'none' : '';
        }

        if (stepNum === 2) {
            loadStrapsIfNeeded();
        }

        if (stepNum === 3) {
            loadBucklesIfNeeded();
        }

        if (stepNum === 4) {
            if (typeof window.initEmbossStep === 'function') {
                window.initEmbossStep();
            }
            if (typeof window.initStitchStep === 'function') {
                window.initStitchStep();
            }
        }

        if (!isMobileLayout) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    function goNext() {
        if (currentStep < totalSteps) {
            if (validateStep(currentStep)) {
                showStep(currentStep + 1);
            }
        } else {
            cart.addToCart();
        }
    }

    function goPrev() {
        if (currentStep > 1) {
            showStep(currentStep - 1);
        }
    }

    function goToStep(stepNum) {
        if (stepNum >= 1 && stepNum <= totalSteps) {
            showStep(stepNum);
        }
    }

    function validateStep(stepNum) {
        switch (stepNum) {
            case 1:
                return !!(state.getState().width && state.getState().strapLength);
            case 2: {
                const s = state.getState();
                if (s.isDouble) {
                    return !!(s.strapVariantId && s.innerStrapVariantId);
                }
                return !!s.strapVariantId;
            }
            case 3:
                return !!(state.getState().buckleVariantId && state.getState().strapThickness);
            case 4: {
                const s = state.getState();
                return !!(s.end && s.stitch && s.emboss);
            }
            default:
                return true;
        }
    }

    function updateProgress() {
        document.querySelectorAll('.progress-step').forEach((step, index) => {
            const stepNum = index + 1;
            if (stepNum < currentStep) {
                step.classList.add('completed');
                step.classList.remove('active');
            } else if (stepNum === currentStep) {
                step.classList.add('active');
                step.classList.remove('completed');
            } else {
                step.classList.remove('active', 'completed');
            }
        });
    }

    function updateButtons() {
        const prevBtn = document.getElementById('btn-prev');
        const nextBtn = document.getElementById('btn-next');
        const checkoutBtn = document.getElementById('btn-checkout');

        if (prevBtn) prevBtn.disabled = currentStep === 1;

        if (currentStep === totalSteps) {
            if (nextBtn) {
                nextBtn.textContent = 'ADD TO CART';
                nextBtn.classList.add('btn-add-cart', 'btn-next');
            }
            if (checkoutBtn) checkoutBtn.style.display = 'inline-flex';
        } else {
            if (nextBtn) {
                nextBtn.textContent = 'NEXT';
                nextBtn.classList.remove('btn-add-cart');
                nextBtn.classList.add('btn-next');
            }
            if (checkoutBtn) checkoutBtn.style.display = 'none';
        }

        const canProceed = validateStep(currentStep);
        if (nextBtn) nextBtn.disabled = !canProceed;
    }

    function updateSidePanel() {
        const s = state.getState();
        const fields = {
            width: 'side-detail-width',
            strapLength: 'side-detail-length',
            strapName: 'side-detail-strapName',
            buckleName: 'side-detail-buckleName',
            strapThickness: 'side-detail-strapThickness',
            end: 'side-detail-end',
            stitch: 'side-detail-stitch',
            emboss: 'side-detail-emboss'
        };

        Object.keys(fields).forEach(key => {
            const el = document.getElementById(fields[key]);
            if (el) el.textContent = s[key] || '-';
        });

        const innerRow = document.getElementById('side-row-inner');
        const innerEl = document.getElementById('side-detail-innerStrapName');
        if (innerRow && innerEl) {
            if (s.isDouble && s.innerStrapName) {
                innerRow.style.display = '';
                innerEl.textContent = s.innerStrapName;
            } else {
                innerRow.style.display = 'none';
            }
        }

        const innerEmbossRow = document.getElementById('side-row-inner-emboss');
        const innerEmbossEl = document.getElementById('side-detail-innerEmboss');
        if (innerEmbossRow && innerEmbossEl) {
            if (s.isDouble && s.innerEmboss) {
                innerEmbossRow.style.display = '';
                innerEmbossEl.textContent = s.innerEmboss;
            } else {
                innerEmbossRow.style.display = 'none';
            }
        }

        const mobileSummaryMeta = document.getElementById('mobile-summary-meta');
        if (mobileSummaryMeta) {
            const summaryParts = [
                s.width || 'Width',
                s.strapLength || 'Length',
                s.strapName || 'Strap',
                s.buckleName || 'Buckle'
            ];
            mobileSummaryMeta.textContent = summaryParts.join(' · ');
        }

        const mobileSummaryTotal = document.getElementById('mobile-summary-total');
        if (mobileSummaryTotal && typeof price !== 'undefined') {
            mobileSummaryTotal.textContent = price.format(price.calculate().total);
        }

        if (typeof price !== 'undefined') {
            const total = document.getElementById('side-total');
            if (total) total.textContent = price.format(price.calculate().total);
        }
    }

    async function loadStrapsIfNeeded() {
        const container = document.getElementById('strap-list');
        if (!api.isCached('straps')) {
            if (container) container.innerHTML = '<div class="loading-spinner">Loading...</div>';
            await api.getStraps();
        }
        filter.initStraps();
        ui.renderStrapStep();
    }

    async function loadBucklesIfNeeded() {
        const container = document.getElementById('buckle-list');
        if (!api.isCached('buckles')) {
            if (container) container.innerHTML = '<div class="loading-spinner">Loading...</div>';
            await api.getBuckles();
        }
        filter.initBuckles();
        ui.renderBuckleStep();
    }

    function showLoading(stepId) {
        const el = document.getElementById(stepId);
        if (el) el.innerHTML = '<div class="loading-spinner">Loading...</div>';
    }

    function selectStrap(variant) {
        state.setMultiple({
            strapVariantId: variant.id,
            strapSku: variant.sku,
            strapName: variant.metafields.strap_material + ' / ' + (variant.metafields.strap_color || variant.title),
            strapPrice: variant.price,
            strapColor: variant.metafields.strap_color || '',
            strapMaterialName: variant.metafields.strap_material || ''
        });

        summary.update();
    }

    function selectInnerStrap(variant) {
        state.setMultiple({
            innerStrapVariantId: variant.id,
            innerStrapSku: variant.sku,
            innerStrapName: variant.metafields.strap_material + ' / ' + (variant.metafields.strap_color || variant.title),
            innerStrapPrice: variant.price,
            innerStrapColor: variant.metafields.strap_color || '',
            innerStrapMaterial: variant.metafields.strap_material || ''
        });

        summary.update();
    }

    function selectBuckle(variant) {
        state.setMultiple({
            buckleVariantId: variant.id,
            buckleSku: variant.sku,
            buckleName: variant.metafields.buckle_material + ' / ' + (variant.metafields.buckle_specification || variant.title),
            bucklePrice: variant.price,
            buckleMaterial: variant.metafields.buckle_material || '',
            buckleColor: variant.metafields.buckle_color || '',
            buckleWidth: variant.metafields.buckle_width || '',
            buckleTechnology: variant.metafields.buckle_technology || '',
            strapThickness: ''
        });

        const maxThickness = variant.metafields.buckle_thickness || null;
        ui.renderThicknessGrid(maxThickness);

        summary.update();
    }

    return {
        init,
        showStep,
        goNext,
        goPrev,
        goToStep,
        selectStrap,
        selectInnerStrap,
        selectBuckle
    };
})();

document.addEventListener('DOMContentLoaded', builder.init);